import "./HeroImage2Styles.css";

import React, { Component } from "react";

class HeroImage2 extends Component {
  render() {
    return (
      <div className={this.props.bgImage}>
        <div className="heading">
          <h1>{this.props.heading}</h1>
          <p className="center-text">{this.props.text}</p>
        </div>
      </div>
    );
  }
}

export default HeroImage2;
